<template>
  <div>
    <div class="bg-hrad">
      <div class="container">
        <div class="header-mcct">
          <img width="156px" height="42px" src="@/assets/img/mynextpay-white.svg" />
          <h2 class="text-transform text-white">upload file chứng từ theo yêu cầu</h2>
        </div>
      </div>
    </div>
    <section class="container" style="min-height: 66vh">
      <template v-if="!firstLoading">
        <div v-if="!state" class="breadcrumb-area p-0 pos-relative w-100">
          <h1>Upload file chứng từ theo yêu cầu</h1>
          <div style="float: right">
            <button
              v-if="canUpload"
              :disabled="
                (transFile.length == 0 &&
                  transImage.length == 0 &&
                  cardFile.length == 0 &&
                  cardImage.length == 0) ||
                showloading === true
              "
              @click="updateFile"
              class="btn btn-primary ml-2"
            >
              Gửi chứng từ
            </button>
          </div>
        </div>
        <div class="card py-10 pt-15 b-t-1-869fb229 w-100">
          <div v-if="!state" class="card-body form-row" style="font-size: 13px; color: black">
            <div class="col-sm-6 mb-3" style="padding-right: 10px">
              <div class="pb-3">
                <p>
                  Kính gửi Quý đơn vị <b>{{ variable.mcName }}</b>
                </p>
                <p>Căn cứ theo:</p>
                <ul>
                  <li style="list-style-type: disc; margin-left: 20px; margin-bottom: 8px">
                    Văn bản hợp nhất 03/VBHN-NHNN ngày 15/11/2021 Thông tư quy định về hoạt động thẻ
                    ngân hàng Điều 8 – Các hành vi bị cấm, Khoản 2;
                  </li>
                  <li style="list-style-type: disc; margin-left: 20px; margin-bottom: 8px">
                    Chỉ thị 02/CT- NHNN Ngày 07/01/2021 - Về việc tăng cường phòng, chống, ngăn ngừa
                    vi phạm pháp luật trong hoạt động thẻ ngân hàng, thì khi các giao dịch mang tính
                    rủi ro.
                  </li>
                  <li style="list-style-type: disc; margin-left: 20px; margin-bottom: 8px">
                    Điều 7, khoản b - Về các hành vị bị nghiêm cấp khi thực hiện việc thanh toán qua
                    cổng MPOS theo hợp đồng đã kí kết giữa MPOS và Quý đơn vị.
                  </li>
                </ul>
                <p>
                  Thì giao dịch có thông tin sau đang bị Ngân hàng & Tổ chức phát hành thẻ thông báo
                  nghi ngờ là giao dịch rùi ro với lý do: <b>{{ variable.riskTypeLabel }}</b>
                </p>
              </div>
              <div class="form-detail">
                <h1>Thông tin giao dịch MPOS</h1>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Ngày giao dịch<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.tsDate }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Mã giao dịch MPOS<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.tsId }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Loại giao dịch<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.tsType }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Phương thức thanh toán<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.tsMethod }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="form-detail">
                <h1>Thông tin thẻ thanh toán</h1>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Tên chủ thẻ<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.cardOwner }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Số thẻ<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.cardNumber }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Loại thẻ<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.cardType }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="pb-3">
                <p style="line-height: 18px; padding-bottom: 8px">
                  Vì vậy, phía Ngân hàng & Tổ chức phát hành thẻ đã yêu cầu MPOS & Quý đơn vị phối
                  hợp cung cấp chứng từ hợp lệ để chứng minh có giao dịch mua bán thật tại Quý đơn
                  vị.
                </p>
                <p style="line-height: 18px">
                  Đứng ở phương diện đơn vị cung cấp giải pháp thanh toán & bảo vệ ĐVCNT, MPOS đề
                  nghị Quý ĐVCNT
                  <b>{{ variable.mcName }}</b> cung cấp các chứng từ của giao dịch này để gửi cho
                  Ngân hàng & Tổ chức phát hành thẻ bằng cách làm theo hướng dẫn trên trang này.
                </p>
              </div>
            </div>
            <div class="col-sm-6 mb-3" style="padding-left: 10px">
              <div class="img-list-wrapper">
                <h1 class="form-inner-heading">Upload thông tin chứng từ</h1>
                <div>
                  <div>
                    <h1 class="form-inner-heading">1. Chứng từ liên quan đến giao dịch</h1>
                    <i
                      >Hướng dẫn:
                      <ul class="b">
                        <li>
                          Nếu là giao dịch trực tiếp cần cung cấp: Hoá đơn bán lẻ, VAT, Phiếu thu,
                          Phiếu giao hàng, Phiếu xuất kho, Hợp đồng...
                        </li>
                        <li>
                          Nếu là giao dịch trực tuyến cần cung cấp: Hình ảnh tin nhắn, Sao kê trừ
                          tiền, File ghi âm, Mail trao đổi, Chứng từ xác nhận đã giao dịch, ...
                        </li>
                      </ul>
                    </i>
                    <br />
                    <p>Upload file PDF, ghi âm, video, ...</p>
                    <div class="form-group img-list">
                      <div v-if="canUpload">
                        <input
                          accept=".pdf, audio/*, video/*"
                          class="input-file"
                          style="display: none"
                          id="file-trans"
                          ref="transFile"
                          @change="uploadFile($event, 'transFile')"
                          type="file"
                        />
                        <label
                          v-if="transFile.length < 4"
                          style="width: 30%"
                          tabindex="0"
                          for="file-trans"
                          class="btn btn-outline-secondary"
                          >Chọn file tải lên
                        </label>
                      </div>
                      <div
                        v-for="(item, index) in transFile"
                        :key="index"
                        style="background-color: #f5f5f5"
                      >
                        <div class="box-header">
                          <b
                            class="text-primary d-inline-block"
                            style="
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              overflow: hidden;
                              width: 90%;
                            "
                            ><a :href="item.name">{{ item.name }}</a></b
                          >
                          <span
                            v-if="canUpload"
                            @click="removeFile(item.id)"
                            class="cursor float-right"
                            ><i class="bx bx-trash bx-sm"></i
                          ></span>
                        </div>
                      </div>
                    </div>

                    <p>Upload ảnh</p>
                    <div class="form-group img-list">
                      <ul class="m-0" v-viewer>
                        <li v-for="(item, index) in transImage" :key="index">
                          <a href="javascript:void(0)">
                            <img :src="item.url" />
                            <span v-if="canUpload" @click="removeFile(item.id)">
                              <i class="bx bx-trash bx-sm"></i>
                            </span>
                          </a>
                        </li>
                        <li>
                          <div v-if="canUpload && transImage.length < 10" class="add-img">
                            <span class="bx bx-plus text-center"></span>
                            <input
                              type="file"
                              ref="transImage"
                              accept="image/jpeg, image/png"
                              @change="uploadImage($event, 'transImage')"
                            />
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div>
                    <h1 class="form-inner-heading">2. Chứng từ liên quan đến thông tin chủ thẻ</h1>
                    <i
                      >Các thông tin cần cung cấp: Ảnh hộ chiếu, CMND/CCCD (Chụp 2 mặt), Hình ảnh
                      khách hàng giao dịch tại đơn vị, Hình ảnh trích xuất camera khách giao dịch,
                      Hình ảnh khách hàng tại cửa hàng
                    </i>
                    <br />
                    <p>Upload file PDF, ghi âm, video, ...</p>
                    <div class="form-group img-list">
                      <div v-if="canUpload">
                        <input
                          accept=".pdf, audio/*, video/*"
                          class="input-file"
                          style="display: none"
                          id="file-card"
                          ref="cardFile"
                          @change="uploadFile($event, 'cardFile')"
                          type="file"
                        />
                        <label
                          v-if="cardFile.length < 4"
                          style="width: 30%"
                          tabindex="0"
                          for="file-card"
                          class="btn btn-outline-secondary"
                          >Chọn file tải lên
                        </label>
                      </div>
                      <div
                        v-for="(item, index) in cardFile"
                        :key="index"
                        style="background-color: #f5f5f5"
                      >
                        <div class="box-header">
                          <b
                            class="text-primary d-inline-block"
                            style="
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              overflow: hidden;
                              width: 90%;
                            "
                            ><a :href="item.name">{{ item.name }}</a></b
                          >
                          <span
                            v-if="canUpload"
                            @click="removeFile(item.id)"
                            class="cursor float-right"
                            ><i class="bx bx-trash bx-sm"></i
                          ></span>
                        </div>
                      </div>
                    </div>
                    <p>Upload ảnh</p>
                    <div class="form-group img-list">
                      <ul class="m-0" v-viewer>
                        <li v-for="(item, index) in cardImage" :key="index">
                          <a href="javascript:void(0)">
                            <img :src="item.url" />
                            <span v-if="canUpload" @click="removeFile(item.id)">
                              <i class="bx bx-trash bx-sm"></i>
                            </span>
                          </a>
                        </li>
                        <li>
                          <div v-if="canUpload && cardImage.length < 10" class="add-img">
                            <span class="bx bx-plus text-center"></span>
                            <input
                              type="file"
                              ref="cardImage"
                              accept="image/jpeg, image/png"
                              @change="uploadImage($event, 'cardImage')"
                            />
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else-if="state === 'act_done'"
            class="card-body form-row"
            style="font-size: 13px; color: black; justify-content: center"
          >
            <div class="col-offset-3 col-sm-6 mb-3" style="padding-right: 10px">
              <div class="pb-3">
                <p style="line-height: 18px; padding-bottom: 8px">
                  Kính chào Quý đơn vị <b>{{ variable.mcName }}</b>
                </p>
                <p style="line-height: 18px; padding-bottom: 8px">
                  MPOS đang làm việc cùng phía Ngân hàng và Tổ chức phát hành thẻ để thẩm định giao
                  dịch của Quý đơn vị. Chúng tôi có thể liên hệ với Quý đơn vị nếu có yêu cầu bổ
                  sung chứng từ trong quá trình thẩm định.
                </p>
                <p style="line-height: 18px">
                  Quý đơn vị có thể theo dõi trạng thái xử lý công việc và xem thông tin lại thông
                  tin giao dịch tại đây:
                </p>
              </div>
              <div class="form-detail">
                <h1>Trạng thái xử lý công việc</h1>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Ngày tạo yêu cầu<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.createdDate }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Ngày cung cấp chứng từ<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.uploadDate }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Trạng thái xử lý<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.statusPublic }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="form-detail">
                <h1>Thông tin giao dịch MPOS</h1>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Ngày giao dịch<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.tsDate }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Mã giao dịch MPOS<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.tsId }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Loại giao dịch<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.tsType }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Phương thức thanh toán<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.tsMethod }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="form-detail">
                <h1>Thông tin thẻ thanh toán</h1>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Tên chủ thẻ<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.cardOwner }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Số thẻ<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.cardNumber }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Loại thẻ<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.cardType }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else-if="state === 'process_done'"
            class="card-body form-row"
            style="font-size: 13px; color: black; justify-content: center"
          >
            <div class="col-offset-3 col-sm-6 mb-3" style="padding-right: 10px">
              <div class="pb-3">
                <p style="line-height: 18px; padding-bottom: 8px">
                  Kính chào Quý đơn vị <b>{{ variable.mcName }}</b>
                </p>
                <p style="line-height: 18px; padding-bottom: 8px">
                  Việc thẩm định giao dịch của quý đơn vị đã hoàn tất. Để kiểm tra thời gian dự kiến
                  thanh toán, quý đơn vị vui lòng truy cập trang mpos.vn hoặc ứng dụng Merchant360
                  trên điện thoại và đăng nhập.
                </p>
                <p style="line-height: 18px">
                  Quý đơn vị có thể xem thông tin lại thông tin giao dịch tại đây:
                </p>
              </div>
              <div class="form-detail">
                <h1>Trạng thái xử lý công việc</h1>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Ngày tạo yêu cầu<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.createdDate }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Ngày cung cấp chứng từ<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.uploadDate }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Trạng thái xử lý<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.statusPublic }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="form-detail">
                <h1>Thông tin giao dịch MPOS</h1>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Ngày giao dịch<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.tsDate }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Mã giao dịch MPOS<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.tsId }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Loại giao dịch<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.tsType }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Phương thức thanh toán<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.tsMethod }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="form-detail">
                <h1>Thông tin thẻ thanh toán</h1>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Tên chủ thẻ<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.cardOwner }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Số thẻ<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.cardNumber }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Loại thẻ<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ variable.cardType }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </section>
    <div class="bg-ef">
      <div class="container">
        <div class="footer-mcct">
          <p class="t">CÔNG TY CỔ PHẦN CÔNG NGHỆ VIMO</p>
          <p class="i">
            <i>Tầng 12A, toà nhà VTC Online, số 18 Tam Trinh, Phường Tương Mai, Hà Nội</i>
          </p>
          <p class="i">
            <i>Hotline: 1900.63.69.56 | Email: hotro@nextpay.vn</i>
          </p>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showloading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { JogetService } from '@/services/joget.service.js'
  import Config from '@/thirdParty/config'
  import md5 from 'md5'
  import moment from 'moment'
  import { v4 as uuidv4 } from 'uuid'
  export default {
    data() {
      return {
        Config,
        variable: {},
        showloading: false,
        firstLoading: false,
        errorMessage: '',
        fileUploads: [],
        activityId: null,
        canUpload: false,
        state: null,
      }
    },
    computed: {
      transFile: vm => vm.fileUploads.filter(s => s.type === 'transFile'),
      transImage: vm => vm.fileUploads.filter(s => s.type === 'transImage'),
      cardFile: vm => vm.fileUploads.filter(s => s.type === 'cardFile'),
      cardImage: vm => vm.fileUploads.filter(s => s.type === 'cardImage'),
    },
    async created() {
      try {
        this.showloading = true
        this.firstLoading = true
        await this.getDetailMerchant()
      } catch (error) {
      } finally {
        this.showloading = false
        this.firstLoading = false
      }
    },
    methods: {
      async getDetailMerchant() {
        const params = {
          accessKey: this.$route.query.token,
          activityId: 'CT001_selfService',
          processId: this.$route.params.processId,
        }
        const res = await JogetService.getActivity(params)
        switch (res.code) {
          case 101:
          case 100:
          case 104:
          case 8101:
            this.showFailMx('Không tồn tại yêu cầu hoặc yêu cầu đã được xử lý!')
            break
          case 103:
            this.state = 'process_done'
            this.canUpload = false
            break
          case 102:
            this.state = 'act_done'
            this.canUpload = false
            break
          case 1000:
            if (res.data.length > 0) {
              this.activityId = res.data[0].id
              this.canUpload = true
            }
            break
          default:
            break
        }
        const resLicense = await JogetService.getVariable(params)
        if (resLicense.code === 1000) {
          resLicense.data.variable.forEach(v => {
            Object.assign(this.variable, v)
          })
          this.fileUploads = []
          const mappingData = (arr, type) =>
            arr.forEach(url => {
              if (url !== '') {
                const ar = { name: url, url, type, id: uuidv4() }
                this.fileUploads.push(ar)
              }
            })
          mappingData(this.variable.lcTsUrls.split(','), 'transFile')
          mappingData(this.variable.lcTsUrlsImg.split(','), 'transImage')
          mappingData(this.variable.lcCardOwnerUrls.split(','), 'cardFile')
          mappingData(this.variable.lcCardOwnerUrlsImg.split(','), 'cardImage')
        }
      },
      uploadFile(e, type) {
        const file = e.target.files[0]
        if (file.size > 20 * 1024 * 1024) {
          alert('Upload tối đa 20MB')
          return
        }
        this.fileUploads.push({
          id: uuidv4(),
          name: file.name,
          file,
          type,
        })
        this.$refs[type].value = null
      },
      uploadImage(e, type) {
        const file = e.target.files[0]
        this.fileUploads.push({
          id: uuidv4(),
          name: file.name,
          url: URL.createObjectURL(file),
          file,
          type,
        })
        this.$refs[type].value = null
      },
      removeFile(id) {
        this.fileUploads = this.fileUploads.filter(s => s.id !== id)
      },
      async sendFile(item) {
        if (item.file) {
          const formData = new FormData()
          const now = moment().valueOf()
          formData.append('file', item.file)
          formData.append('accessKey', md5(`FQY0DYG7V89OT52B${now}`))
          formData.append('time', now)
          const data = await JogetService.uploadFile(formData)
          if (data.success === false) return Promise.reject(data.message)
          const urlFile = data.data
          return { urlFile, type: item.type }
        } else return { urlFile: item.url, type: item.type }
      },
      async totalSubmit() {
        const allPromises = this.fileUploads.map(s => this.sendFile(s))
        return Promise.all(allPromises).then(res => {
          const returnData = {
            licenceTransactionUrls: [],
            licenceTransactionUrlsImg: [],
            licenceCardOwnerUrls: [],
            licenceCardOwnerUrlsImg: [],
          }
          res.forEach(s => {
            if (s.type === 'transFile') {
              returnData.licenceTransactionUrls.push(s.urlFile)
            }
            if (s.type === 'transImage') {
              returnData.licenceTransactionUrlsImg.push(s.urlFile)
            }
            if (s.type === 'cardFile') {
              returnData.licenceCardOwnerUrls.push(s.urlFile)
            }
            if (s.type === 'cardImage') {
              returnData.licenceCardOwnerUrlsImg.push(s.urlFile)
            }
          })
          return returnData
        })
      },
      async updateFile() {
        try {
          this.showloading = true
          const result = await this.totalSubmit()
          const variable = `var_lcTsUrls=${result.licenceTransactionUrls.join(',')}&var_lcTsUrlsImg=${result.licenceTransactionUrlsImg.join(',')}&var_lcCardOwnerUrls=${result.licenceCardOwnerUrls.join(',')}&var_lcCardOwnerUrlsImg=${result.licenceCardOwnerUrlsImg.join(',')}`
          const data = await JogetService.completeActivity({
            activityId: this.activityId,
            variable,
          })
          if (data.status === 200) {
            this.showSuccessMx('Gửi yêu cầu thành công')
            this.canUpload = false
          } else {
            this.showFailMx('Gửi yêu cầu thất bại')
          }
        } catch (e) {
          this.showFailMx(e)
        } finally {
          this.showloading = false
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .header-mcct {
    padding: 25px 0;
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    h2 {
      font-size: 32px;
      text-align: center;
    }
    img {
      display: none;
    }
  }
  .bg-hrad {
    background-color: #3979b5;
  }
  .bg-ef {
    background-color: #efefef;
  }
  .footer-mcct {
    padding: 25px 0;
    display: flex;
    flex-direction: column;
    p {
      line-height: normal;
    }
    .i {
      font-size: 11px;
    }
  }
  @media (min-width: 768px) {
    .header-mcct {
      img {
        display: block;
      }
      h2 {
        font-size: 36px;
      }
    }
  }
</style>
